import React from 'react';
import Slider from 'react-slick';
import Footer from './Footer';
import mh1 from './img/k1.jpg';
import mh2 from './img/k2.jpg';
import mh3 from './img/k3.jpg';
import mh4 from './img/k4.jpg';

import google from '../component/img/goole.jpg'

// Import slick-carousel CSS
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

// Custom arrow components
const SampleNextArrow = (props) => {
    const { className, onClick } = props;
    return (
        <div className={className} onClick={onClick} style={{ ...arrowStyles, right: '10px' }}>
            <i className="fa fa-chevron-right" aria-hidden="true"></i>
        </div>
    );
};

const SamplePrevArrow = (props) => {
    const { className, onClick } = props;
    return (
        <div className={className} onClick={onClick} style={{ ...arrowStyles, left: '10px' }}>
            <i className="fa fa-chevron-left" aria-hidden="true"></i>
        </div>
    );
};

// Styles for the arrows
const arrowStyles = {
    position: 'absolute',
    top: '50%',
    zIndex: 1,
    fontSize: '24px',
    color: '#000',
    cursor: 'pointer',
    transform: 'translateY(-50%)',
    background: 'rgba(255, 255, 255, 0.7)', // Optional background for visibility
    borderRadius: '50%',
    padding: '10px',
};

const Kedardham = () => {
    // Settings for the slider
    const settings = {
        dots: true, // Display navigation dots
        infinite: true, // Infinite scrolling
        speed: 500, // Transition speed
        slidesToShow: 4, // Number of slides to show at once
        slidesToScroll: 1, // Number of slides to scroll at once
        arrows: true, // Show left/right arrows
        nextArrow: <SampleNextArrow />, // Custom next arrow
        prevArrow: <SamplePrevArrow />, // Custom prev arrow
        responsive: [
            {
                breakpoint: 1024, // Tablet breakpoint
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 768, // Mobile breakpoint
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 480, // Extra small mobile breakpoint
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    };

    return (
        <div>
            <Slider {...settings}>
                <div className='image-container'>
                    <img src={mh1} alt="Mahacal 1" />
                </div>
                <div className='image-container'>
                    <img src={mh2} alt="Mahacal 2" />
                </div>
                <div className='image-container'>
                    <img src={mh3} alt="Mahacal 3" />
                </div>
                <div className='image-container'>
                    <img src={mh4} alt="Mahacal 4" />
                </div>
            </Slider>


            <div className='mahacals'>
                <h2>Kedarnath  Packages From Lucknow</h2>
                <p><strong>Location:</strong> Lucknow, Gomtinagar</p>
                <p><strong>Price:</strong> ₹49,999.00</p>
                <p><strong>Duration:</strong> 4 days</p>
                <p><strong>Tour Type:</strong> Holiday Package (with Stay) <br /> <br />  <span style={{ fontSize: '14px' }}> * T&C Apply</span></p>
            </div>


            <div className='packedges   '>

                <div className='newpacks'>

                    <h1>Kedarnath Packages From Lucknow</h1>
                    <p>Get the best deals on Kedarnath  packages from Lucknow flat 20% off on your first booking.</p>

                    <p>Kedarnath, a paradisiacal place steeped in spirituality and nestled in the majestic Himalayas, is a dream destination for pilgrims and nature lovers alike. Home to one of the twelve Jyotirlingas of Lord Shiva, the Kedarnath Temple stands as a symbol of divine power and ancient heritage. Surrounded by snow-capped peaks and pristine valleys, Kedarnath offers not only religious fulfillment but also breathtaking natural beauty.</p> <p>Traveling from Lucknow to Kedarnath is a journey of devotion and adventure. The total distance is approximately 550 kilometers and involves a combination of train, road, and a final trek to the temple. Travelers can take a train or bus from Lucknow to Haridwar or Rishikesh, and from there continue by road to Gaurikund — the base point for the 16 km trek to Kedarnath. For those unable to trek, helicopter services are also available, offering a quicker and scenic option.</p> <p>The route from Lucknow to Kedarnath is not just about reaching the destination, but experiencing the transformation along the way — from bustling cityscapes to peaceful Himalayan trails. Travel platforms like Indiator provide useful services, including transport bookings, trekking support, and guided pilgrimage tours, making your journey to Kedarnath smooth and spiritually enriching.</p>
                </div>



                <div className='newpacks googles'>

                    <div className="cards">
                        <h2>Tour Information</h2>
                        <p><strong>Max Guests:</strong> 60</p>
                        <p><strong>Min Age:</strong> 12</p>
                        <p><strong>Location:</strong> <span class="location">Kedarnath  </span></p>
                        <p className="languages"><strong>Languages Supported:</strong> Hindi, English</p>

                    </div>

                    <div className='google'>
                        <img src={google} />
                        <button><a href='https://www.google.com/search?q=prism+travels+lucknow&oq=prism'> <i class="fa fa-google-plus"></i> Google Review</a></button>
                    </div>





                </div>


            </div>



            <Footer />
        </div>
    );
};

export default Kedardham;
